/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ plan: NonNullable<unknown> }} Plan_Gate_Available_OnInputs */



/**
* | output |
* | --- |
* | "Available on {plan} and above" |
*
* @param {Plan_Gate_Available_OnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_gate_available_on = /** @type {((inputs: Plan_Gate_Available_OnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Gate_Available_OnInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Verfügbar ab ${i?.plan} und höher`)
	return /** @type {LocalizedString} */ (`Available on ${i?.plan} and above`)
});